import React from 'react';

import { Select } from 'antd';

import { Icon } from '@eduzz/ui-antd-theme';

export interface IAutocompleteOption {
  value: number;
  label: string;
}

interface Props {
  options: IAutocompleteOption[];
  selectedOptions: IAutocompleteOption[];
  onChange: (event: React.ChangeEvent<Element>, value: IAutocompleteOption[]) => void;
}

export const Autocomplete = ({ options = [], selectedOptions = [], onChange }: Props) => {
  const handleSelect = (value: string[]) => {
    onChange(
      null as any,
      options.filter(o => value.includes(String(o.value)))
    );
  };

  return (
    <div className='mt-6'>
      <Select
        mode='tags'
        className='w-full'
        options={options.map(option => ({ value: option.value.toString(), label: option.label }))}
        value={selectedOptions.map(option => option.value.toString())}
        onChange={handleSelect}
        placeholder={!selectedOptions.length ? 'Buscar por nome ou ID do produto' : ''}
        suffixIcon={<Icon.Search />}
        labelRender={props => props.value}
      />
    </div>
  );
};
